import { Text } from "@wojo/ui";
import React, { HtmlHTMLAttributes } from "react";
import styles from "./TripBuilderDeparturesStep.module.scss";

export const DepartureListHeadingCell: React.FC<
    HtmlHTMLAttributes<HTMLTableCellElement>
> = ({ children, ...props }) => {
    return (
        <th className={styles["table-heading"]} {...props}>
            <Text.Body emphasis="1" tag="span">
                {children}
            </Text.Body>
        </th>
    );
};
